<div class="holes-panel">
  <div class="holes-panel__body">
    <div class="panel-header">
      <img src="assets/icon/Holes.svg" alt="" />
      <span class="title">{{ 'GLOBAL.HOLES_LEGEND' | translate }}</span>
    </div>

    <div class="tabs">
      <button type="button" [class.active]="store.holesPanelTab() === 'state'" (click)="store.holesPanelTab.set('state')">{{ 'GLOBAL.HOLES_PANEL_STATE' | translate }}</button>
      <button type="button" [class.active]="store.holesPanelTab() === 'feature'" (click)="store.holesPanelTab.set('feature')">{{ 'GLOBAL.HOLES_PANEL_FEATURE' | translate }}</button>
    </div>

    @if (store.holesPanelTab() === 'state') {
      <div class="holes-legend">
        <label class="hole-option">
          <input type="radio" name="siteMapHoleStatus" [checked]="store.holeStatusFilter() === 'actual'" (change)="store.setHoleStatusFilter('actual')" />
          <span class="radio-mark"></span>
          <span class="hole-option__all"></span>
          <span class="hole-option__text">{{ 'GLOBAL.ACTUAL_HOLES' | translate }}</span>
        </label>
        @for (status of statuses; track status) {
          <label class="hole-option">
            <input type="radio" name="siteMapHoleStatus" [checked]="store.holeStatusFilter() === status" (change)="store.setHoleStatusFilter(status)" />
            <span class="radio-mark"></span>
            <img [src]="statusIcon(status)" [alt]="status" />
            <span class="hole-option__text">{{ 'HOLE.' + status | translate }}</span>
          </label>
        }
      </div>
    } @else {
      <div class="holes-legend">
        <label class="hole-option">
          <input type="radio" name="siteMapHoleFeature" [checked]="store.holeFeatureFilter() === 'all'" (change)="store.setHoleFeatureFilter('all')" />
          <span class="radio-mark"></span>
          <span class="hole-option__all"></span>
          <span class="hole-option__text">Tous les trous</span>
        </label>
        @for (option of features; track option.feature) {
          <label class="hole-option">
            <input type="radio" name="siteMapHoleFeature" [checked]="store.holeFeatureFilter() === option.feature" (change)="store.setHoleFeatureFilter(option.feature)" />
            <span class="radio-mark"></span>
            <img class="hole-option__feature-icon" [src]="option.icon" [alt]="option.label" />
            <span class="hole-option__text">{{ option.label }}</span>
          </label>
        }
      </div>
    }
  </div>
</div>
